<template>
  <div>
    <!-- 最后一级菜单 -->
    <el-menu-item v-if="!HasChildren(row)" :key="row.name" :index="row.name">
      <i :class="row.meta.icon"></i>
      <span>{{ row.meta.title }}</span>
    </el-menu-item>

    <!-- 此菜单下还有子菜单 -->
    <el-submenu v-else :key="row.name" :index="row.name">
      <template slot="title">
        <i :class="row.meta.icon"></i>
        <span>{{ row.meta.title }}</span>
      </template>
      <!--递归-->
      <nodes v-for="item in filterRows(row.children)" :key="item.name" :row="item" :basePath="resolvePath(row.path)" />
    </el-submenu>
  </div>
</template>

<script>
import path from 'path'
export default {
  name: 'nodes',
  props: {
    row: { type: Object, required: true },
    basePath: { type: String, default: '' },
  },
  methods: {
    //判断是否有下级
    HasChildren (row) {
      if (row.children) {
        if (row.children.filter((m) => !m.meta.hidden).length == 0) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
    //过滤隐藏菜单
    filterRows (rows) {
      return rows.filter((m) => !m.meta.hidden)
    },
    //组装路由
    resolvePath (routePath) {
      return path.resolve(this.basePath, routePath)
    },
  },
};
</script>
